var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-hidden"}},[_c('Player',{key:"hidden.playback.h0",attrs:{"debug":"","muted":"","controls":"","grid":1,"src":_vm.playback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }